import { render, staticRenderFns } from "./PurchaseStatusBadge.vue?vue&type=template&id=3ff7c1be&scoped=true&"
import script from "./PurchaseStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PurchaseStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7c1be",
  null
  
)

export default component.exports